import React from 'react';
import { StudentCounselModel } from '../../../../models';
import { Calendar, User, ChevronRight, Reply } from 'lucide-react';

interface StudentCounselCardProps {
    log: StudentCounselModel;
    onClick: () => void;
}

const StudentCounselCard: React.FC<StudentCounselCardProps> = ({ log, onClick }) => {
    const isStudent = (log as any).isStudentWrite;

    return (
        <button
            onClick={onClick}
            className="w-full bg-white rounded-xl border border-slate-100 hover:border-indigo-200 transition-all cursor-pointer overflow-hidden shadow-sm hover:shadow-md text-left group"
        >
            <div className="p-4 flex items-center gap-4">
                <div className={`w-10 h-10 rounded-xl ${isStudent ? 'bg-indigo-600' : 'bg-rose-500'} text-white flex items-center justify-center shrink-0 shadow-sm`}>
                    <User size={18} />
                </div>

                <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2 mb-1">
                        <span className={`${isStudent ? 'bg-indigo-50 text-indigo-600 border-indigo-100' : 'bg-rose-50 text-rose-600 border-rose-100'} text-[10px] font-bold uppercase px-2 py-0.5 rounded-md border`}>
                            {log.tag}
                        </span>
                        <div className="flex items-center gap-1 text-[10px] font-bold text-slate-300">
                            <Calendar size={10} /> {log.date}
                        </div>
                    </div>
                    <h4 className="text-sm font-bold text-slate-800 truncate mb-1">
                        {log.title}
                    </h4>
                    <p className="text-xs text-slate-500 truncate font-medium">
                        {log.content}
                    </p>
                </div>

                <div className="flex items-center gap-3">
                    {/* Status Badge */}
                    {isStudent ? (
                        log.reply ? (
                            <div className="hidden sm:flex px-2 py-1 bg-emerald-50 text-emerald-600 rounded-lg text-[10px] font-bold uppercase items-center gap-1">
                                <Reply size={10} />
                                <span>답변 완료</span>
                            </div>
                        ) : (
                            <div className="hidden sm:flex px-2 py-1 bg-slate-50 text-slate-400 rounded-lg text-[10px] font-bold uppercase">
                                대기중
                            </div>
                        )
                    ) : (
                        <div className="hidden sm:flex px-2 py-1 bg-rose-50 text-rose-500 rounded-lg text-[10px] font-bold uppercase">
                            선생님 기록
                        </div>
                    )}

                    <div className="text-slate-300 group-hover:text-indigo-400 transition-colors">
                        <ChevronRight size={18} />
                    </div>
                </div>
            </div>
        </button>
    );
};

export default StudentCounselCard;
